import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const JunoLabel = styled.label`
  display: block;
  color: var(--juno-color-text);

  font-size: var(--juno-font-size-body-sm);
  line-height: normal;
  margin-bottom: 0.5em;
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }
`;

const JunoBoldLabel = styled(Label)`
  font-weight: var(--juno-font-weight-bold);
`;

function Label(props) {
  return <JunoLabel {...props}>{props.children}</JunoLabel>;
}

export function BoldLabel(props) {
  return <JunoBoldLabel>{props.children}</JunoBoldLabel>;
}

export default Label;
